import type {AnyObject} from '@/types/Common'
import {useI18n} from 'vue-i18n'
import dayjs from 'dayjs'
import {isFieldRequired, createRequiredLabel} from '@/helpers/validators/utils'

export enum Locale {
  Ru = 'ru',
  Kk = 'kk',
}

export function useLocale() {
  const {locale, t} = useI18n()

  dayjs.locale(locale.value)

  const optionsLocales = [
    {
      value: Locale.Ru,
      label: t('language.ru'),
    },
    {
      value: Locale.Kk,
      label: t('language.kk'),
    },
  ]

  function changeLocale(value: string) {
    dayjs.locale(value)

    locale.value = value
  }

  function placeholder(obj?: AnyObject) {
    if (locale.value === Locale.Ru) {
      return obj?.['placeholderRu']
    }

    return obj?.['placeholderKk'] || obj?.['placeholderKz']
  }
  function label(obj?: AnyObject) {
    if (locale.value === Locale.Ru) {
      return obj?.['labelRu']
    }

    return obj?.['labelKk'] || obj?.['labelKz']
  }

  /**
   * Creates a label with required indicator if the field has required validation
   * @param obj - Object containing label data
   * @param rules - Static validation rules
   * @param serverRules - Server-side validation rules
   * @param validationRulesProps - Props containing server validation rules
   * @param attributeName - Name of the attribute to check
   * @returns HTML string with label and optional red asterisk
   */
  function labelWithRequired(
    obj?: AnyObject,
    rules: Array<(value: any) => any> = [],
    serverRules: Array<(value: any) => any> = [],
    validationRulesProps?: Record<string, any[]>,
    attributeName?: string,
  ): string {
    const labelText = label(obj)
    const required = isFieldRequired(rules, serverRules, validationRulesProps, attributeName)
    return createRequiredLabel(labelText, required)
  }

  /**
   * Returns the help text based on the current locale
   * @param obj - Object containing help data
   * @returns Help text for current locale
   */
  function help(obj?: AnyObject): string {
    if (locale.value === Locale.Ru) {
      return obj?.['helpRu'] || ''
    }

    return obj?.['helpKk'] || ''
  }


  return {
    locale,
    optionsLocales,
    changeLocale,
    placeholder,
    label,
    help,
    labelWithRequired,
    t,
  }
}
